{"dirty":false,"raw":"8fbaca971","hash":"8fbaca971","distance":null,"tag":null,"semver":null,"suffix":"8fbaca971","semverString":null}